import type {AxiosRequestConfig} from 'axios';
// import {Bundle, Status, CancelBundle} from './interface';

export class GetAllInvoicesRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/invoices',
    params: {},
  };
  params(params: object) {
    this.bundleRequest.params = params;
    return this;
  }
  build() {
    return this.bundleRequest;
  }
}
export class GetInvoicesRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
    params: {},
  };
  params(params: object) {
    this.bundleRequest.params = params;
    return this;
  }

  id(id: number) {
    this.bundleRequest.url = `/invoices/${id}`;
    return this;
  }
  build() {
    return this.bundleRequest;
  }
}
export class GetInvoicesFileRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };
  id(id: number) {
    this.bundleRequest.url = `/invoices/${id}/file`;
    return this;
  }
  build() {
    return this.bundleRequest;
  }
}
export class GetInvoicesCountRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/invoices/count',
  };
  params(params: object) {
    this.bundleRequest.params = params;
    return this;
  }
  build() {
    return this.bundleRequest;
  }
}

export class GetInvoiceLogsBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '',
  };
  id(id: number) {
    this.bundleRequest.url = `invoices/${id}/logs`;
    return this;
  }

  build() {
    return this.bundleRequest;
  }
}

export class CreateInvoiceRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/invoices',
    data: {},
  };
  params(params: object) {
    console.log('params')
    console.log(params)
    this.bundleRequest.params = params;
    return this;
  }
  data(data: any) {
    console.log('data')
    console.log(data)
    this.bundleRequest.data = data;
    return this;
  }

  build() {
    return this.bundleRequest;
  }
}

export class UpdateInvoiceRequestBuilder {
  private readonly bundleRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/invoices',
    data: {},
  };
  params(params: object) {
    console.log('params')
    console.log(params)
    this.bundleRequest.params = params;
    return this;
  }
  
  data(data: any) {
    console.log('data')
    console.log(data)
    this.bundleRequest.data = data;
    return this;
  }

  build() {
    return this.bundleRequest;
  }
}

export class UpdateInvoiceStatusRequestBuilder {
  private readonly invoiceRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/invoices',
    data: {},
  };
  params(params: object) {
    this.invoiceRequest.params = params;
    return this;
  }
  
  id(id: any) {
    this.invoiceRequest.url = `/invoices/${id}/status`;
    return this;
  }

  build() {
    return this.invoiceRequest;
  }
}

export class RemoveInvoiceRequestBuilder {
  private readonly invoiceRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '/invoices',
    data: {},
  };
  
  id(id: any) {
    this.invoiceRequest.url = `/invoices/${id}`;
    return this;
  }

  build() {
    return this.invoiceRequest;
  }
}





// export class UploadBundlesRequestBuilder {
//   private readonly uploadProductsReq: AxiosRequestConfig = {
//     method: 'POST',
//     url: '/bundles/uploadFile',
//     data: {},
//   };

//   data(body: any) {
//     this.uploadProductsReq.data = body;
//     return this;
//   }

//   build() {
//     return this.uploadProductsReq;
//   }
// }
